<div *ngFor="let event of events"
     [style.top]="getTopPosition(event)"
     [style.height]="getHeight(event)"
     class="calendar-event calendar-event__{{viewType}}">
  <ng-container
    [ngTemplateOutlet]="eventTemplate"
    [ngTemplateOutletContext]="{ $implicit: event}">
  </ng-container>
</div>
